/**
 * @generated SignedSource<<f945fec5a57d500c83f80a91a515547c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditElementsPoolElementInput = {
  answerOptions: ReadonlyArray<AnswerOptionV2Input>;
  answeringType: string;
  clientMutationId?: string | null | undefined;
  elementId: string;
  imageId?: string | null | undefined;
  poolId: string;
  question: string;
  title: string;
};
export type AnswerOptionV2Input = {
  answer: string;
  imageRef?: string | null | undefined;
  isCorrect: boolean;
};
export type MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation$variables = {
  input: EditElementsPoolElementInput;
};
export type MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation$data = {
  readonly Admin: {
    readonly Elementspool: {
      readonly editElementsPoolElement: {
        readonly pool: {
          readonly elements: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment">;
          }>;
          readonly id: string;
        };
      } | null | undefined;
    };
  };
};
export type MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation = {
  response: MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation$data;
  variables: MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "editElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "editElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "question",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "answeringType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AnswerOptionV2",
                            "kind": "LinkedField",
                            "name": "answerOptions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "answer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCorrect",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a00f29a45bc423021ab79ade4e48190",
    "id": null,
    "metadata": {},
    "name": "MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation",
    "operationKind": "mutation",
    "text": "mutation MultipleChoicePoolElementForm_EditMultipleChoiceElementV2Mutation(\n  $input: EditElementsPoolElementInput!\n) {\n  Admin {\n    Elementspool {\n      editElementsPoolElement(input: $input) {\n        pool {\n          id\n          elements {\n            ...MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5d8612038e4b89457a489a50c05a76b";

export default node;
